import fetchAndCheckStatus from '../../edlio-js/utils/fetchAndCheckStatus';

/*
 * Token used on public site to create payment
 */

export default async (formName) => {
  const endpoint = encodeURI(`/apps/pay/token${formName ? `?formTitle=${formName}` : ''}`);

  const postObj = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json'
    },
    cache: 'no-store'
  }

  return await fetchAndCheckStatus(endpoint, [200], postObj);
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-api/pay/getPublicPayToken.js